import i18next from "i18next";

export default class textUtils {
    static getNumber (count) {
        const cases = [2, 0, 1, 1, 1, 2];
        return (count % 100 > 4 && count % 100 < 20) ? 2 : cases[Math.min(count % 10, 5)];
    };

    static getPluralIndex(count) {

        const language = i18next.language;

        /* Английский */
        if (language === 'en') {
            return count === 1 ? 'one' : 'other';
        }

        // Русский и Украинский
        const lastDigit = count % 10;
        const lastTwoDigits = count % 100;

        if (lastDigit === 1 && lastTwoDigits !== 11) return 'one';
        if (lastDigit >= 2 && lastDigit <= 4 && (lastTwoDigits < 10 || lastTwoDigits >= 20)) return 'few';
        return 'many';
    };

    static pluralize(count, words = ['день', 'дня', 'дней']) {
        return count + ' ' + words[this.getNumber(count)];
    }

    static pluralize_i18next(count, prefix = "daysCountPostfix") {
        return count + ' ' + i18next.t(`${prefix}.${this.getNumber(count)}`);
    }

    /* расширенная версия с учетом правил английского и украинского языков */
    static pluralize_i18next_ex(count, prefix) {
        if (!prefix) return null;
        return count + ' ' + i18next.t(`${prefix}.${this.getPluralIndex(count)}`);
    }
};